export const DEFAULT_TOASTS: { [key in HttpMethod]: ToastMessage } = {
  GET: {},
  PATCH: { success: 'Erfolgreich aktualisiert', error: 'Aktualisieren fehlgeschlagen' },
  DELETE: { success: 'Erfolgreich gelöscht', error: 'Löschen fehlgeschlagen' },
  POST: { success: 'Erfolgreich gespeichert', error: 'Speichern fehlgeschlagen' },
  PUT: { success: 'Erfolgreich aktualisiert', error: 'Aktualisieren fehlgeschlagen' },
};

export interface ToastMessage {
  error?: string;
  success?: string;
}

enum HttpMethod {
  GET = 'GET',
  PUT = 'PUT',
  PATCH = 'PATCH',
  POST = 'POST',
  DELETE = 'DELETE',
}
